import React, { useEffect, useState } from "react";
import A4Document from "./A4Document";
import { companyToProfile } from "../lib/storage";

// Headless print page used by the backend (WhatsApp) to render the EXACT same A4Document the web app renders.
export default function PrintQuote({ token }) {
  const [job, setJob] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/print/${token}`)
      .then(async (r) => { if (!r.ok) throw new Error(await r.text()); return r.json(); })
      .then(setJob)
      .catch((e) => setError(String(e.message || e)));
  }, [token]);

  useEffect(() => {
    if (!job) return;
    const imgs = Array.from(document.images);
    Promise.all(imgs.map((im) => (im.complete ? Promise.resolve() : new Promise((res) => { im.onload = res; im.onerror = res; }))))
      .then(() => (document.fonts?.ready || Promise.resolve()))
      .then(() => { document.body.setAttribute("data-print-ready", "1"); });
  }, [job]);

  if (error) return <div data-testid="print-error" style={{ padding: 24, fontFamily: "monospace" }}>{error}</div>;
  if (!job) return null;

  const profile = companyToProfile(job.company);
  const company = { ...profile.company, logo: profile.logo };
  const theme = {
    primary: profile.colors.primary,
    font: profile.font,
    cover: profile.doc?.cover ?? false,
    coverTitle: profile.doc?.coverTitle ?? "Proposta Comercial",
    headerLabel: profile.doc?.headerLabel ?? "Orçamento",
    logoRight: profile.doc?.logoRight ?? false,
    logoSize: profile.doc?.logoSize || "md",
    coverImage: profile.doc?.coverImage ?? "",
    coverBg: profile.doc?.coverBg ?? "",
  };
  return (
    <div className="print-root" data-testid="print-root">
      <style>{`
        @page { size: 794px 1123px; margin: 0; }
        html, body { margin: 0; padding: 0; background: #fff; }
        .print-root .a4-sheet { box-shadow: none !important; margin: 0 !important; break-after: page; page-break-after: always; }
        .print-root .a4-sheet:last-child { break-after: auto; page-break-after: auto; }
        .print-root tr, .print-root p, .print-root textarea, .print-root img { break-inside: avoid; page-break-inside: avoid; }
        .print-root thead { display: table-header-group; }
        .print-root .pdf-exclude { display: none !important; }
      `}</style>
      <A4Document layout={profile.layout} company={company} theme={theme} data={job.quote} editable={false} branding={!!job.branding} />
    </div>
  );
}
